<template>
  <div class="no-content-maxvalu-kantou">
    ただいまチラシの掲載はございません。
  </div>
</template>

<script>

</script>

<style lang="scss" scoped>
.no-content-maxvalu-kantou {
  font-family: 'ヒラギノ角ゴ Pro W3', 'Hiragino Kaku Gothic Pro', Osaka,
    メイリオ, Meiryo, 'ＭＳ Ｐゴシック', 'MS PGothic', sans-serif;
  margin: 0;
  padding: 0;
  font-size: 13px;
  @media screen and (min-width: 440px) {
    font-size: 16px;
  }
}
</style>
